import React from 'react'
import { View, StyleSheet } from 'react-native'
import { BtText } from '@linqpal/components/src/ui'

interface DetailRowProps {
  label: string
  value: string | number
  isRed?: boolean
  isTotal?: boolean
  withDivider?: boolean
}

export const DetailRow: React.FC<DetailRowProps> = ({
  label,
  value,
  isRed = false,
  isTotal = false,
  withDivider = false,
}) => {
  return (
    <View style={[styles.container, withDivider && styles.withDivider]}>
      <View style={styles.row}>
        <BtText
          style={[
            styles.rowLabel,
            isRed && styles.redText,
            isTotal && styles.boldValue,
          ]}
        >
          {label}
        </BtText>
        <BtText
          style={[
            styles.rowLabel,
            styles.rowValue,
            isRed && styles.redText,
            isTotal && styles.boldValue,
          ]}
        >
          {value}
        </BtText>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 12,
  },
  withDivider: {
    borderBottomWidth: 1,
    borderBottomColor: '#DEE5EB',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rowLabel: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 24,
    color: '#001929',
  },
  rowValue: {
    fontWeight: '700',
    maxWidth: '50%',
    textAlign: 'right',
  },
  boldValue: {
    fontWeight: '700',
  },
  redText: {
    color: '#EC002A',
  },
})
